import React, { useEffect, useContext } from 'react';
import { ExtendedContentContainer, ExtendedContentType, ExtendedContentCanvasContext, getCanvasSvg } from 'components/ExtendedContent/ExtendedContentContainer';
import { ExtendedContentCanvas } from 'components/ExtendedContent/ExtendedContentCanvas';
import VolumeOneWords from 'components/VolumeOneWords';
import { WordLearningContentWrapper } from 'components/WordLearningGrid/WordLearningContent';
import WordContentList from 'components/WordContentList';
import { ExtensionType } from 'constants/wordGrid';
import { useStore, StoreTypes } from 'context';
import * as actionTypes from 'constants/actionTypes';
import classnames from 'classnames'
import styles from './index.module.scss';

const convertIdiomResource = data =>
  Object.entries(data).map(([key, item]) => ({ label: item.label, value: item.relatedWords[0] }))

const MeaningContent = ({ data, list }) => {
  const [{
    word,
    extensionType
  }, wordGridDispatch] = useStore(StoreTypes.wordGrid);

  // 語詞教學為單頁內容，容器在 WordGridSubContent 型別下不掛 canvas，
  // 故比照 VerticalGridView 由內容自帶畫布：canvasState / 尺寸 / 已存筆跡皆取自容器 context。
  const {
    canvasState,
    canvasDispatch,
    canvasWidth,
    canvasHeight,
    isContentInit,
    svgContent,
  } = useContext(ExtendedContentCanvasContext) || {};

  const onListChangeHandler = ({ word, relatedWords }) => {
    wordGridDispatch({
      type: actionTypes.SET_SUBCONTENT_SHOW,
      payload: {
        isShowSubContent: true,
        extensionType
      }
    })


    word && wordGridDispatch({
      type: actionTypes.SET_WORDS_VALUE,
      payload: {
        word
      }
    })

    wordGridDispatch({
      type: actionTypes.SET_RELATED_WORDS,
      payload: {
        relatedWords
      }
    })

  }

  useEffect(() => {
    const current = list.filter(item => item.value === word);
    if (current.length > 0) {
      onListChangeHandler({ relatedWords: current[0].relatedWords, word })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={classnames(styles.meaningContentWrapper, styles.zhuyin)}>
      <WordLearningContentWrapper data={data} />
      {/* 已存筆跡：畫筆停用時以 SVG 疊層顯示（live canvas 停用時會 display:none，靠這層維持畫記） */}
      {svgContent && (!canvasState || !canvasState.isActive) && (
        <div
          style={{ position: 'absolute', inset: 0, zIndex: 100, pointerEvents: 'none' }}
          dangerouslySetInnerHTML={{ __html: getCanvasSvg(svgContent) }}
        />
      )}
      {/* live 畫布：尺寸取自容器 contentView（canvasWidth/Height），啟用時才吃指標事件 */}
      {isContentInit && canvasState && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            zIndex: 101,
            pointerEvents: canvasState.isActive ? 'auto' : 'none',
          }}
        >
          <ExtendedContentCanvas
            canvasState={canvasState}
            canvasDispatch={canvasDispatch}
            canvasWidth={canvasWidth}
            canvasHeight={canvasHeight}
          />
        </div>
      )}
      {/* WordContentList 疊在 canvas 之上（bottomOverlay z-index 120 > canvas 101），
          空白處 pointer-events:none 讓畫筆可穿透續畫，按鈕本身可點——比照 VerticalGridView */}
      <div className={styles.bottomOverlay}>
        <WordContentList
          zhuyin
          word={word}
          className={styles.wordContentList}
          data={list.map(item => {
            return {
              label: item.label,
              value: item.value,
              relatedWords: [item.value]
            }
          })}
          onChange={onListChangeHandler}
        />
      </div>
    </div>
  )
}


const WordLearningGridContainer = ({
  wordGridResource,
  defaultWord,
  wordsResource
}) => {
  const [{
    isShowSubContent,
    extensionType,
    extensionData,
  }, wordGridDispatch] = useStore(StoreTypes.wordGrid);


  const subContentCloseHandler = () => {
    wordGridDispatch({ type: actionTypes.SET_SUBCONTENT_SHOW, payload: { isShowSubContent: false } })
  }

  useEffect(() => {
    wordGridDispatch({
      type: actionTypes.SET_WORDS_VALUE,
      payload: {
        word: defaultWord
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <ExtendedContentContainer extendedContentType={ExtendedContentType.WordGrid}>
        <VolumeOneWords dataList={wordGridResource} defaultWord={defaultWord} />
      </ExtendedContentContainer>
      {
        isShowSubContent && (
          <ExtendedContentContainer
            extendedContentType={ExtendedContentType.WordGridSubContent}
            onClose={subContentCloseHandler}
          >
            <div className={styles.wordGridConentContainer}>
              {
                extensionType === ExtensionType.WordsSet && (
                  <MeaningContent data={extensionData[ExtensionType.WordsSet]} list={convertIdiomResource(wordsResource)} />
                )
              }
            </div>
          </ExtendedContentContainer>
        )
      }
    </>
  )
}

export const VolumeOneWordsModalComponent = ({
  wordGridResource,
  defaultWord,
  wordsResource
}) => {
  return (
    <WordLearningGridContainer
      wordGridResource={wordGridResource}
      defaultWord={defaultWord}
      wordsResource={wordsResource}
    />
  )
};
